export const TEXTS = {
  VALIDATION: {
    TITLE: 'Решите пример, чтобы подтвердить\n отправку email',
    DEFAULT_WARNING: 'Записаться на эфир можно только\nсо взрослым',
  },
  COMPLETED: {
    TITLE: 'Спасибо за заявку!',
    TEXT: 'Скоро мы свяжемся с вами, чтобы сообщить дату и время эфира',
  },
};
